import { z } from 'zod'

export const QuickAction = z.union([
  z.literal('aboutTheBrand'),
  /**
   * This is for a user that wants know more about the products this brand is selling. It is for brand-centric ads.
   */
  z.literal('questionAboutProducts'),
  /**
   * This is for a user that wants know more about other produts from the same brand. It is for product-centric ads.
   */
  z.literal('similarBrandProducts'),
  z.literal('aboutTheProduct'),
  z.literal('followUsOnSocialMedia'),
])

export type QuickAction = z.infer<typeof QuickAction>
